export const CLASSNAME = 'qlfeditor-rewards__list';
